import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateAppTranslationMutationVariables = Types.Exact<{
  input: Types.CreateAppTranslationInput;
}>;


export type CreateAppTranslationMutation = { __typename?: 'Mutation', createAppTranslation: { __typename?: 'AppTranslationEntry', id: string, name: string, url: string, app_type?: string | null, created_at: string, updated_at: string } };


export const CreateAppTranslationDocument = gql`
    mutation createAppTranslation($input: CreateAppTranslationInput!) {
  createAppTranslation(input: $input) {
    id
    name
    url
    app_type
    created_at
    updated_at
  }
}
    `;
export type CreateAppTranslationMutationFn = Apollo.MutationFunction<CreateAppTranslationMutation, CreateAppTranslationMutationVariables>;

/**
 * __useCreateAppTranslationMutation__
 *
 * To run a mutation, you first call `useCreateAppTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppTranslationMutation, { data, loading, error }] = useCreateAppTranslationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppTranslationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppTranslationMutation, CreateAppTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppTranslationMutation, CreateAppTranslationMutationVariables>(CreateAppTranslationDocument, options);
      }
export type CreateAppTranslationMutationHookResult = ReturnType<typeof useCreateAppTranslationMutation>;
export type CreateAppTranslationMutationResult = Apollo.MutationResult<CreateAppTranslationMutation>;
export type CreateAppTranslationMutationOptions = Apollo.BaseMutationOptions<CreateAppTranslationMutation, CreateAppTranslationMutationVariables>;